import React from "react";
import { View, Text, ScrollView } from "react-native";
import UserCard from "./UserCard";

const UserGridSection = ({ title, users = [], onChat }: any) => {
  return (
    <View className="bg-white rounded-xl p-4 mb-4 border border-gray-200 flex-100 max-h-[333px]">
      <Text className="text-lg font-semibold text-gray-800 mb-2">{title}</Text>
      {users.length === 0 ? (
        <Text className="text-gray-500 italic">No users found.</Text>
      ) : (
        <ScrollView horizontal className="pb-2">
          {users.map((user: any) => (
            <UserCard key={user.id} user={user} onChat={onChat} />
          ))}
        </ScrollView>
      )}
    </View>
  );
};

export default UserGridSection;
